module.exports = __webpack_public_path__ + "img/40_38_020_200.d4fc5e4b.jpg";